import React from 'react';
import type { ServicedeskBoardAppLayout as ServicedeskBoardType } from '@jira/spa-apps__servicedesk-board/src/ServicedeskBoardAppLayout.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskBoard: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskBoardType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-board", jiraSpaEntry: "async-servicedesk-board" */ '@jira/spa-apps__servicedesk-board/src/ServicedeskBoard.tsx'
		),
	),
);

export const LazyBoardSettings: LazyComponent<() => React.JSX.Element | null> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jsm-board-settings", jiraSpaEntry: "async-jsm-board-settings" */ '@jira/spa-apps__servicedesk-board-settings/src/ServicedeskBoardSettingsAppLayout.tsx'
		).then((module) => module.ServicedeskBoardSettingsAppLayout),
	),
);

export const ServicedeskBoard = (props: RouteContext): React.JSX.Element | null => {
	const { route, query } = props;

	if (route.name !== 'servicedesk-boards') {
		return null;
	}

	return query.config ? (
		<LazyPage
			Page={LazyBoardSettings}
			pageId="spa-apps/servicedesk/boards/board-settings"
			shouldShowSpinner
		/>
	) : (
		<LazyPage
			Page={LazyServicedeskBoard}
			pageId="spa-apps/servicedesk/boards/board"
			shouldShowSpinner
		/>
	);
};
